/**
 * CrmProtectedRoute — guard для /crm страниц.
 *
 * Поведение:
 * - Пока идёт проверка (isLoading) → показываем спиннер.
 * - Не авторизован → redirect на /crm/login
 * - Если авторизован как admin → redirect на /admin (admin не должен использовать CRM)
 * - Авторизован как CRM → render children
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCrmAuth } from '../../hooks/useCrmAuth';
import { useAdminAuth } from '../../hooks/useAdminAuth';

export function CrmProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated: isCrmAuthed, isLoading: isCrmLoading } = useCrmAuth();
  const { isAuthenticated: isAdminAuthed, isLoading: isAdminLoading } = useAdminAuth();

  const isLoading = isCrmLoading || isAdminLoading;

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#09090B] flex items-center justify-center">
        <div className="text-zinc-600 text-xs uppercase tracking-widest">Проверка сессии...</div>
      </div>
    );
  }

  // Если авторизован как admin — не даём доступ к CRM через /crm, редиректим в админку
  if (isAdminAuthed) {
    return <Navigate to="/admin" replace />;
  }

  if (!isCrmAuthed) {
    return <Navigate to="/crm/login" replace />;
  }

  return <>{children}</>;
}
